import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'
import { RemoteLoadSchooling } from '../../../data/usecases/load-schooling/remote-load-schooling'

export const makeLoadSchooling = () => new RemoteLoadSchooling('/cotacao/schoolingLoad', makeAxiosHttpClient())
